"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDialCodeForCountry = exports.getCountryCode = void 0;
var countryCodes_1 = require("./countryCodes");
var getCountryCode = function (phoneNumber, countryCode) {
    var _a, _b, _c;
    if (phoneNumber) {
        var phoneNumberWithPlus_1 = "+".concat(phoneNumber).replace('++', '+');
        var results = countryCodes_1.countryCodes.filter(function (country) { return phoneNumberWithPlus_1.indexOf(country.dial_code) === 0; });
        results.sort(function (a, b) { return b.dial_code.length - a.dial_code.length; });
        return (_b = (_a = results[0]) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
    }
    if (countryCode) {
        var country = countryCodes_1.countryCodes.find(function (cc) { return cc.code.toLowerCase() === countryCode.toLowerCase(); });
        return (_c = country === null || country === void 0 ? void 0 : country.code) !== null && _c !== void 0 ? _c : '';
    }
    return '';
};
exports.getCountryCode = getCountryCode;
var getDialCodeForCountry = function (countryCode) {
    var _a;
    var country = countryCodes_1.countryCodes.find(function (cc) { return cc.code === countryCode; });
    return (_a = country === null || country === void 0 ? void 0 : country.dial_code) !== null && _a !== void 0 ? _a : '';
};
exports.getDialCodeForCountry = getDialCodeForCountry;
